// Modules
import Head from "next/head";

// Components
import Pagination from "components/Pagination/Pagination";
import ActiveProduct from "components/Products/ActiveProduct";
import InactiveProduct from "components/Products/InactiveProduct";
import ChosenFilter from "components/SearchResults/ChosenFilter";
import SectionContentUtils from "components/SearchResults/SectionContentUtils";
import QueryFilter from "components/SearchResults/QueryFilter";

// Constants
import {ProductState} from "constants/gpoSearchEnum";

// Redux
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { suggestionsSearchResultSelector } from "redux/searchBar/searchBarSlice";
import { isOpenMobileSidebarSelector, productVisibilitySelector, setOpenMobileSidebar } from "redux/filters/filtersSlice";
import {seoInfoPageSelector} from "redux/seoInformations/seoInformationsSlice";
import {endedCourseSelector} from "redux/showResults/showResultsSlice";

const SearchResults = () => {
	const dispatch = useAppDispatch();
	const seoInfoPage = useAppSelector(seoInfoPageSelector);
	const searchResults = useAppSelector(suggestionsSearchResultSelector);
	const productsVisibility = useAppSelector(productVisibilitySelector);
	const isOpenMobileSidebar = useAppSelector(isOpenMobileSidebarSelector);
	const endedCourse = useAppSelector(endedCourseSelector);

	return (
		<>
			<div className="btn blu full toggle-sidebar filters-button">
				<button type="button" onClick={() => dispatch(setOpenMobileSidebar(!isOpenMobileSidebar))}>
					{!isOpenMobileSidebar ? "Mostra Filtri" : "Nascondi Filtri"}
				</button>
			</div>
			<div className="section-content">
				<div className="section-content__intro">
					{searchResults && (searchResults.totalRows === 0 || searchResults.totalRows === 1) ? (
						<Head>
							<meta name="robots" content="noindex, nofollow" />
						</Head>
					) : null}
					<h1 className="section-content__intro__title">{seoInfoPage.h1 || "Altalex"} </h1>
					<p id="ctl00_MainContent_tag_paragraph" className="section-content__intro__sub">
						{seoInfoPage.paragraph}
					</p>
				</div>
				<div className="wk-choosen-filters">
					{QueryFilter()}
					{ChosenFilter()}
				</div>
				<SectionContentUtils totalNumberOfCourses={searchResults.totalRows} />
				<div id="ctl00_MainContent_PanelListaFormazione" className={`section-content__product-list section-content__product-list--${productsVisibility}-view`}>
					<div id="ctl00_MainContent_ListaProdottiFormazione_Main" className="UC ShopProductList prodottiCollegati">
						<div className="list prodotti">
							<div className="elementi active-products-list">
								{searchResults.results && searchResults.results.length > 0 &&
									searchResults.results
										.filter(
											(result) =>
												result.grouping === ProductState.NOTSTARTED_VALID || result.grouping === ProductState.ELEARNING_VALID
										)
										.map((product) => <ActiveProduct key={product.documentId} product={product} />)
								}
							</div>

							<div className="elementi inactive-products-list">
								{searchResults.results && endedCourse.length > 0 && (
									<>
										<p className="inactive-card-list-text">Iniziative in corso o concluse</p>
										{endedCourse.map((result) => (
											<InactiveProduct key={result.documentId} product={result} />
										))}
									</>
								)}
							</div>
							<Pagination />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default SearchResults;
